import { SPECIES_GROUPS } from '../../map.constants';

function getChartData(feature) {
  const taxaObservations = feature?.properties?.taxaObservations ?? {};

  const chartData = Object.entries(SPECIES_GROUPS)
    .map(([key, config]) => ({
      key,
      label: config.label,
      color: config.color,
      fill: config.color,
      icon: config.icon,
      value: taxaObservations[key]?.sum ?? 0,
    }))
    .filter(({ value }) => value > 0);

  const total = chartData.reduce((sum, { value }) => sum + value, 0);

  return { chartData, total };
}

export {
  getChartData,
};
